// WebComponent
if (!customElements.get('multi-product-compare')) {
    class MultiProductCompare extends HTMLElement {
        constructor() {
            super();
            this.previewNum = this.dataset.rowPreview;
            this.button = this.querySelector('.multi-product-compare__view-button');
            this.viewMoreText = this.button.dataset.viewMore;
            this.viewLessText = this.button.dataset.viewLess;
            this.table = this.querySelector('.multi-product-compare__table tbody');
            this.scrollBar = this.querySelector('.multi-product-compare__scroll-bar');
            this.scrollTrack = this.querySelector('.multi-product-compare__scroll-track');
            this.scrollContainer = this.querySelector('.multi-product-compare__item');
        }

        connectedCallback() {
            this.buttonFunction();
            this.variantChange();
            this.scrollTrackFunction();
        }

        variantChange() {
            const itemMainProducts = this.table.querySelectorAll('.multi-product-compare__item-main-product');
            itemMainProducts.forEach((itemMainProduct) => {
                const colorButtons = itemMainProduct.querySelectorAll('.multi-product-compare__item-main-product__product-info__color-button');
                if (colorButtons.length > 0) {
                    colorButtons.forEach((colorButton) => {
                        colorButton.addEventListener('click', () => {
                            const variantId = colorButton.dataset.variantId;
                            const imagesContainer = itemMainProduct.querySelector('.multi-product-compare__item-main-product-variant-images');
                            const image = imagesContainer.querySelectorAll('.multi-product-compare__item-main-product-variant-image');
                            // 处理button的active类
                            colorButtons.forEach((btn) => {
                                btn.classList.remove('active');
                            });
                            colorButton.classList.add('active');

                            // 先移除所有image的active类
                            image.forEach((img) => {
                                img.classList.remove('active');
                            });
                            // 再添加点击的colorButton的data-variant-id的image的active类
                            image.forEach((img) => {
                                if (img.dataset.variantId === variantId) {
                                    img.classList.add('active');
                                }
                            });
                        });
                    });
                }
            });
        }

        buttonFunction() {
            const itemRows = this.table.querySelectorAll('.multi-product-compare__item-row');
            const previewNum = Number(this.previewNum);

            if (itemRows.length <= previewNum) return;

            this.button.classList.remove('hidden');

            // 初始状态：折叠
            let expanded = false;

            const collapseRows = () => {
                itemRows.forEach((row, index) => {
                    if (index >= previewNum) {
                        row.classList.add('hidden');
                    }
                });
                this.button.textContent = this.viewMoreText;
                expanded = false;
            };

            const expandRows = () => {
                itemRows.forEach((row) => {
                    row.classList.remove('hidden');
                });
                this.button.textContent = this.viewLessText;
                expanded = true;
            };

            // 初始化折叠
            collapseRows();

            this.button.addEventListener('click', () => {
                if (expanded) {
                    collapseRows();
                } else {
                    expandRows();
                }
            });
        }

        scrollTrackFunction() {
            const container = this.scrollContainer;
            const bar = this.scrollBar;
            const track = this.scrollTrack;

            if (!container || !bar || !track) return;

            const updateScrollBar = () => {
                const containerWidth = container.clientWidth;
                const scrollWidth = container.scrollWidth;
                const barWidth = bar.clientWidth;

                // 如果内容不需要滚动
                if (scrollWidth <= containerWidth) {
                    bar.classList.add('hidden');
                    return;
                } else {
                    bar.classList.remove('hidden');
                }

                // track宽度 = 可视区域比例
                const trackWidth = (containerWidth / scrollWidth) * barWidth;
                track.style.width = `${trackWidth}px`;

                // 计算位置
                const maxScrollLeft = scrollWidth - containerWidth;
                const maxTrackMove = barWidth - trackWidth;

                const scrollLeft = container.scrollLeft;
                const trackLeft = (scrollLeft / maxScrollLeft) * maxTrackMove;

                track.style.transform = `translateX(${trackLeft}px)`;
            };

            // 监听横向滚动
            container.addEventListener('scroll', () => {
                updateScrollBar();
            });

            // 监听窗口变化
            window.addEventListener('resize', () => {
                updateScrollBar();
            });

            // 初始化
            updateScrollBar();
        }

    }
    customElements.define('multi-product-compare', MultiProductCompare);
}